import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { HoverText } from '@campfire/hover-link';
import { unpackToDateTime } from '@campfire/hot-date';
import { SideBarItem } from '../../../../../program-manager/activity-management/activities-list/SideBarActivityDetail';
import { useDownloadCertificate } from '../../../../../../common/certificates/useDownloadCertificate';
import { AchievementBadge } from '../../my-achievements/AchievementBadge';
import { CertificateDownloadButton } from '../../../../../../common/certificates/CertificateDownloadButton';
import { useVolDashboardMyElementsContext } from '../../VolDashboardMyElementsContext';

const MAX_BADGES = 6;

interface Props {
  onViewAllClick: () => void;
}

export const SideBarYourAchievementsSection = ({ onViewAllClick }: Props) => {
  const {
    myAchievements: { enabled, hasAny, awards, certificates },
    newAchievementIds,
  } = useVolDashboardMyElementsContext();
  const isNew = (id: string, seenAt: string | null) => !seenAt || Boolean(newAchievementIds?.has(id));
  const { download, downloading } = useDownloadCertificate();

  if (!enabled || !hasAny) return null;

  const latestCertificate = certificates[0];

  return (
    <SideBarItem
      headerTitle='Your Achievements'
      headerActionItems={
        <HoverText color='primary' variant='body2' style={{ fontSize: '12px' }} onClick={onViewAllClick}>
          View All
        </HoverText>
      }
    >
      {awards.length > 0 && (
        <Box display='flex' flexWrap='wrap' style={{ gap: '14px' }} mt='18px'>
          {awards.slice(0, MAX_BADGES).map((award) => (
            <Box
              key={award.awardedAchievementId}
              width='64px'
              display='flex'
              flexDirection='column'
              alignItems='center'
              style={{ gap: '4px' }}
              title={`${award.level.name} in ${award.level.achievement.name}`}
            >
              <AchievementBadge
                badgeDesign={award.level.badgeDesign}
                label={award.level.name}
                size={48}
                isNew={isNew(award.awardedAchievementId, award.seenAt)}
              />
              <Typography style={{ fontSize: '11px', fontWeight: 600, color: '#444', textAlign: 'center' }}>
                {award.level.name}
              </Typography>
            </Box>
          ))}
        </Box>
      )}
      {latestCertificate && (
        <Box
          display='flex'
          alignItems='center'
          mt='16px'
          p='12px 16px'
          bgcolor='#FAFAFA'
          border='1px solid #EFEFEF'
          borderRadius='4px'
          style={{ gap: '10px' }}
        >
          <Box flex={1} minWidth={0}>
            <Typography style={{ fontSize: '14px', fontWeight: 700, color: '#333' }} noWrap>
              {latestCertificate.awardedFor || latestCertificate.templateName}
            </Typography>
            <Typography style={{ fontSize: '12px', color: '#767676' }}>
              {`Certificate issued ${unpackToDateTime(latestCertificate.issuedAt).toFormat('d MMM yyyy')}`}
            </Typography>
          </Box>
          <CertificateDownloadButton
            iconOnly
            disabled={downloading}
            onClick={() => download(latestCertificate.volunteerCertificateId)}
          />
        </Box>
      )}
    </SideBarItem>
  );
};
